import {Component, ElementRef, OnInit, Optional, ViewChild, HostListener} from '@angular/core';
import {CPCUser} from './CPCUser';
import {CpcWebApiService} from '../cpc-web-api.service';
import {Router} from '@angular/router';
import {Md5} from 'ts-md5/dist/md5';
import {CpcSysInfoService} from '../cpc-sys-info.service';
import {CookieService} from 'angular2-cookie/core';
import {Http} from '@angular/http';
import {loginSucc} from '../animations/loginSucc';
import {ModMenuService} from '../home-page/mod-menu.service';
import {PlatformLocation} from '@angular/common';
import {DomSanitizer} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
//tslint:disable
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [loginSucc],
  providers: []
})
export class LoginComponent implements OnInit {
  infoError = false;
  userInfo: CPCUser = new CPCUser();
  errorMessage = '';
  isLogin = false;
  needMd5 = true;
  @ViewChild('ui') uiInput: ElementRef;
  @ViewChild('pw') pwInput: ElementRef;
  @ViewChild('tip') tip: ElementRef;
  @ViewChild('message') message: ElementRef;
  @ViewChild('qrcode_panel') qrcode_panel: ElementRef;
  // @ViewChild('login_header') login_header: ElementRef;
  @ViewChild('form1') form1: ElementRef;
  @ViewChild('simpleLogin') simpleLogin: ElementRef;
  @ViewChild('message1') message1: ElementRef;
  @ViewChild('loginContent') loginContent: ElementRef;
  @ViewChild('form_con') form_con: ElementRef;

  constructor(
    public sysInfo: CpcSysInfoService,
    private webapi: CpcWebApiService,
    private router: Router,
    private http: Http,
    private menuService: ModMenuService,
    private domSanitizer: DomSanitizer,
    public translateService: TranslateService) {

  }

  data: any;
  loginlogourl;
  backgroundUlr;
  entcode;
  telImgUrl;
  telText;
  qqClickUrl;
  qqImgUrl;
  qqText;
  webtoolURL;
  loginformalign: any; // 登录框偏移位置
  login_box_location: any; // 登录框居中居左居右
  login_text_color: any; // 登录框字体的颜色
  header_bg_color: any; // 顶部条形的背景颜色
  header_text_color: any; // 顶部系统名称字体颜色
  header_download_text_color: any; // 顶部右上角插件下载的
  IsPC() {
    const userAgentInfo = navigator.userAgent;
    const Agents = ['Android', 'iPhone',
      'SymbianOS', 'Windows Phone',
      'iPad', 'iPod'];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }
  curQCode: string; // 生成二维码的地址
  qrCodeName: string = '微信扫码登录'; // 用什么扫码的名字
  qrcodeurl= ''; // 向后台发请求
  hideLoginLogo: Number = 1;
  isSimpleLogin = true; // 直接登录
  supportinfo: any = '';
  ngOnInit() {
    this.loginContent.nativeElement.style.display = 'none'; // 隐藏登录框
    sessionStorage.setItem('router_path', 'login');
    this.getEntCode();
    // 设置默认语言，一般无法匹配的时候使用
    this.translateService.setDefaultLang('zh');
    // 初始化的时候 用浏览器默认的语言
    const browserLang = this.translateService.getBrowserLang();
    console.log('检测到的浏览器语言>' + browserLang);

    this.translateService.use(browserLang);

  }
  selectEntcode = '';
  selectedLanguage: any; // 语言ID
  entcodeList = [];
  languages = [];
  // 多语言的系统名称
  langTitles = {};
  getEntCode() {
    // 加一个版本号，谷歌会有缓存
    const url = '/getEntCode.jsp?v=' + Math.floor(Math.random() * 1000000);
    // console.log(url);
    let aa;
    this.http.get(url).toPromise().then(response => {
      // debugger;
      aa = response.json();
      // console.log( aa);
      if (aa) {
        for (let i = 0; i < aa.length; i++) {
          if (String(aa[i].domain) === window.location.hostname) {
            this.entcode = aa[i].entcode;

            this.sysInfo.logoUrl = aa[i].logourl || './assets/images/xs_logo.png';
            this.sysInfo.title = aa[i].title;
            let  len = 100;
            for (let j = 0; j < len; j++) {
              if( j === 0){
                this.langTitles["title1"] = aa[i].title;
                continue;
              }
              if( typeof aa[i]['title'+ (j+1)] === 'undefined'){
                break;
              }
              else{
                this.langTitles["title"+ (j+1)] = aa[i]['title'+ (j+1)];
              }
            }
            // 有sso的登录地址的时候，并且url上没有会话的时候
            if(aa[i].sinocc_sso_auth_url && !this.getQuery(window.location.href, 'loginguid')){
              location.href = aa[i].sinocc_sso_auth_url;
              break;
            }
            this.sysInfo.loginlogourl = aa[i].loginlogourl;
            this.loginlogourl = aa[i].loginlogourl;
            this.backgroundUlr = aa[i].background_url;
            if (aa[i].hotline_url) {
              this.telImgUrl = aa[i].hotline_url;
            }
            if (aa[i].hotline_number) {
              this.telText = aa[i].hotline_number;
            }
            if (aa[i].qq_number) {
              this.qqClickUrl = 'http://wpa.qq.com/msgrd?v=3&uin=' + aa[i].qq_number + '&site=qq&menu=yes';
            }
            if (aa[i].qq_url) {
              this.qqImgUrl = aa[i].qq_url;
            }
            if (aa[i].qq_text) {
              this.qqText = aa[i].qq_text;
            }
            document.title = this.sysInfo.title;
            if (aa[i].webtoolcrc32) {
              this.webapi.WebtoolCRC32 = aa[i].webtoolcrc32;
            }
            if (aa[i].webtool2crc32) {
              this.webapi.Webtool2CRC32  = aa[i].webtool2crc32;
            }
            if (aa[i].webtoolurl) {
              this.webtoolURL  = aa[i].webtoolurl;
              this.sysInfo.webtoolURL = aa[i].webtoolurl;
            }
            // 若有登录框位置的返回值
            if (aa[i].loginformalign) {
              this.loginformalign = aa[i].loginformalign;
              if (!this.loginformalign.endsWith('%')) {
                this.loginformalign = this.loginformalign + 'px';
              }
            }
            if (aa[i].hideLoginLogo) {
              this.hideLoginLogo = Number(aa[i].hideLoginLogo);
            }
            // 登录框居中居左居右
            if (aa[i].login_box_location) {
                this.login_box_location = aa[i].login_box_location;
            }
            if (aa[i].login_text_color) {
              this.login_text_color = aa[i].login_text_color;
            }
            if (aa[i].header_bg_color) { // 顶部条形的背景颜色
              this.header_bg_color = aa[i].header_bg_color;
            }
            if (aa[i].header_text_color){ // 顶部系统名称字体颜色
              this.header_text_color = aa[i].header_text_color;
            }
            if (aa[i].header_download_text_color) { // 顶部右上角插件下载的字体颜色
              this.header_download_text_color = aa[i].header_download_text_color;
            }
            if (aa[i].sso_logout_url && aa[i].sso_logout_url.length > 0) {
              this.webapi.sso_logout_url = aa[i].sso_logout_url;
            }
            if (aa[i].qrcodeurl && aa[i].qrcodeurl.length > 0) {
              this.qrcodeurl = aa[i].qrcodeurl;
              if (this.IsPC()) {
                this.changeLoginAction('账号密码登录');
                this.qrcode_panel.nativeElement.style.display = 'none';
              } else {
                this.changeLoginAction(this.qrCodeName);
              }
            }
            if (aa[i].entlist && aa[i].entlist.length > 0){
              this.entcodeList = aa[i].entlist;
            }
            if (aa[i].cpclocalelanglist && aa[i].cpclocalelanglist.length > 0) {
              this.languages = aa[i].cpclocalelanglist;
              for (let a = 0; a < this.languages.length; a++) {
                this.sysInfo.langs.push(this.languages[a].localename);
              }
              // 如果仅有一种语言 直接使用当前语言 即可
              if(this.languages.length === 1){
                this.sysInfo._browserLang = this.languages[0].localename;
                this.sysInfo.langId = this.languages[0].langid;
                this.translateService.use(this.sysInfo._browserLang);
              }
            }
            // SSO 单点登录 多语言
            if(this.getQuery(window.location.href,'langid')){
              let langid = Number(this.getQuery(window.location.href,'langid'));
              // 防呆 排除掉非数字的参数
              if (!isNaN(langid)) {
                this.sysInfo.langId  = String(langid);
              }
              for (let a = 0; a < this.languages.length; a++) {
                if( Number(this.languages[a].langid) === langid){
                  // 防呆
                  if (this.languages[a].localename) {
                    this.sysInfo._browserLang = this.languages[a].localename;
                    this.selectedLanguage  = {
                      localename:this.sysInfo._browserLang,
                      langid: this.sysInfo.langId
                    };
                    this.changeLanguage();
                  }
                  break;
                }
              }
            }

            // 备案信息
            if (aa[i].supportinfo && aa[i].supportinfo.trim().length > 0) {
              this.supportinfo = this.domSanitizer.bypassSecurityTrustHtml(aa[i].supportinfo);
            }
            // 扫码的名字
            if (aa[i].qrcodename && aa[i].qrcodename.trim().length > 0) {
              this.qrCodeName = aa[i].qrcodename;
            }

            // 登录方式
            if (aa[i].portallogintype && aa[i].portallogintype.trim().length > 0) {
              const loginType = ['normal', 'weixin'];
              // 系统定义的登录方式
              const systemDefinedLoginType = aa[i].portallogintype.trim().toLowerCase().split(',');

              // 仅仅一种登录方式
              if (systemDefinedLoginType.length === 1) {
                // 仅仅密码登录
                if (systemDefinedLoginType[0] === loginType[0]) {
                    // 直接隐藏 切换到微信登录的按钮
                    document.getElementById('weiChatLogin').style.display = 'none';
                }
                // 仅仅微信登录
                else if (systemDefinedLoginType[0] === loginType[1]) {
                  // 先切换到二维码界面
                  this.changeLoginType();
                  // 直接隐藏 切换到密码登录的按钮
                  // document.getElementById('changeLoginType').style.display = 'none';
                  document.getElementById('passwordLogin').style.pointerEvents = 'none';
                  document.getElementById('weiChatLogin').innerText = this.qrCodeName;
                }
              }
              // 两种都要的时候
              else if (systemDefinedLoginType.length === 2) {
                // 如果优先微信
                if (systemDefinedLoginType[0] === loginType[1]) {
                  this.changeLoginType();
                }
              }
            }

            // 自动登录放到最后 不然有些信息（比如多语言啥的）没有初始化好
            if (this.getQuery(window.location.href, 'loginguid')) {
              this.isSimpleLogin = true;
              this.simpleLogin.nativeElement.style.display = 'block'; // 显示简化登录的提示
              this.uiInput.nativeElement.value = this.getQuery(window.location.href, 'loginguid');
              this.doLogin();
            }else if (aa[i].loginguid && aa[i].loginguid.length > 0) {
              this.isSimpleLogin = true;
              this.simpleLogin.nativeElement.style.display = 'block'; // 显示简化登录的提示
              this.uiInput.nativeElement.value = aa[i].loginguid;
              this.doLogin();
            } else {
              this.isSimpleLogin = false;
              this.loginContent.nativeElement.style.display = 'block'; // 显示登录框
            }
          }
        }
        // 暂不支持二维码登录
        if (this.qrcodeurl.length == 0) {
          // 二维码的扫码区域隐藏
          if (this.qrcode_panel.nativeElement) {
            this.qrcode_panel.nativeElement.style.display = 'none';
          }

          // // 切换登录方式的按钮隐藏
          // if (this.login_header && this.login_header.nativeElement) {
          //   this.login_header.nativeElement.style.display = 'none';
          // }

        }
      }
      if (this.loginformalign) {
        if (this.login_box_location.trim() == 'left') {
          this.form_con.nativeElement.style.left = this.loginformalign;
        } else if (this.login_box_location.trim() == 'right') {
          this.form_con.nativeElement.style.left = 'calc(100% - ' + this.loginformalign + '';
        } else {
          this.form_con.nativeElement.style.left = '50%';
        }
      } else{
        this.form_con.nativeElement.style.left = '50%';
      }
      // // 不是简化登录 从cookie 获取登录信息 登录
      // if (!this.isSimpleLogin) {
      //   let cook_name = this.myCookie("shenling_name", null, null);
      //   let cook_password = this.myCookie("shenling_password", null, null);
      //   if(cook_name != "null__" && cook_name !="" && cook_name !=null){
      //     if(cook_password !="null__" && cook_password !=null && cook_password!=""){
      //       this.uiInput.nativeElement.value = cook_name;
      //       this.pwInput.nativeElement.value = cook_password;
      //       this.doLogin();
      //     }
      //   }
      //
      // }
      this.init();
    });
  }
  doLogin() {
    // debugger;
    if (this.entcodeList.length > 0 && !this.selectEntcode  ) {
      alert('请选择登录的企业！');
      return;
    } else if (this.selectEntcode && this.selectEntcode.length > 0) {
      this.entcode = this.selectEntcode;
    }
    if (this.isLogin) {return false; }
    this.isLogin = true;
    this.infoError = false;
    this.errorMessage = '';
    // 清除缓存
    this.menuService.destroy();
    this.webapi.destroy();
    this.sysInfo.destroy();
    window.sessionStorage.removeItem('TopBarInfo');
    window.sessionStorage.removeItem('SQueueInfo');
    window.sessionStorage.removeItem('docInfo');
    window.sessionStorage.removeItem('sysInfo');
    window.sessionStorage.removeItem('htaccesstoken');
    window.sessionStorage.removeItem('pw');
    window.localStorage.removeItem('pw');
    // 360极速浏览器自动填充表单不会触发change事件，导致ng2中绑定的模型值没同步，这里手动同步.....mdzz
    this.userInfo.userId = this.uiInput.nativeElement.value;
    this.userInfo.password = this.pwInput.nativeElement.value;
    let randomStr = '';
    for (let i = 0; i < this.userInfo.password.length; i++) {
        randomStr += Math.floor(Math.random() * 10)
    }
    // this.langid = this.langid || '1';
    const data = {
      userid: this.userInfo.userId,
      md5sn: Md5.hashStr(this.userInfo.password),
      entcode: this.entcode,
      userpass: 'PORTAL' + this.webapi.base64encode(this.webapi.utf16to8(this.userInfo.password + randomStr)),
      isportal: 2,
      langid: this.sysInfo.langId
    };
    if (this.isSimpleLogin) {
      this.message1.nativeElement.innerText = '正在登录--' + this.sysInfo.title + '，请稍后...';
    } else{
      this.tip.nativeElement.style.display = 'block';
      this.tip.nativeElement.style.width = '200px';
      this.message.nativeElement.innerText = '正在登录，请稍后...';
    }

    this.webapi.post('loginuser', 'login', data).then(
      response => {
        // debugger;

        if (this.isSimpleLogin) {
          this.message1.nativeElement.innerText = '正在加载...';
        } else {
          window.sessionStorage.setItem('pw', this.webapi.base64encode(this.webapi.base64encode(
            this.webapi.utf16to8((this.pwInput.nativeElement.value)))
          )); // 存一下密码 到时候 用户在流程界面调用webtool要用到
          this.uiInput.nativeElement.value = '';
          this.pwInput.nativeElement.value = '';
          this.tip.nativeElement.style.width = '240px';
          this.message.nativeElement.innerText = '登录成功！ 正在跳转，请稍后...';
          this.userInfo.userId = '';
        }

        // 登录成功
        this.isLogin = false;
        const responseData = response.json();
        // 打开表单
        const cookieName = 'CPCREDIRECTURL';
        const strCookie = document.cookie;
        const arrCookie = strCookie.split('; ');
        let newUrl;
        for (let i = 0; i < arrCookie.length; i++) {
          const arr = arrCookie[i].split('=');
          if (cookieName == arr[0]) {
            if (arr[1].length > 0 && arr[1].search(/.css$/i) == -1 && arr[1].search(/.js$/i) == -1) { // 说明有表单的连接 && 链接不是css不是js
              newUrl = arr[1];
              if (newUrl.indexOf('?') > 0) {

                if (newUrl.substring(newUrl.indexOf('?') + 1).length > 0) {
                  newUrl = newUrl + '&loginguid=' + responseData.loginguid;
                } else {
                  newUrl = newUrl + 'loginguid=' + responseData.loginguid;
                }
              } else {
                newUrl = newUrl + '?loginguid=' + responseData.loginguid;
              }

            }
          }
        }
        if (newUrl) {
          if (newUrl.indexOf('%3D') != -1) {
            newUrl = newUrl.replace('%3D', '=');
          }
          console.log(newUrl);
          window.location.href = newUrl;
        } else {
          this.webapi.setLoginGUId(responseData.loginguid);
          this.sysInfo.userInfo.userId = responseData.userid;
          this.sysInfo.userInfo.userName = responseData.username;
          this.sysInfo.userInfo.sysuserid = responseData.sysuserid;
          this.sysInfo.userInfo.md5sn = responseData.md5sn;
          this.sysInfo.userInfo.password = this.userInfo.password;
          this.sysInfo.userInfo.email = responseData.email;
          this.sysInfo.userInfo.mobile = responseData.mobil;
          this.sysInfo.userInfo.currmrporgid = responseData.currmrporgid;
          this.sysInfo.userInfo.entid = responseData.entid;
          this.sysInfo.userInfo.entofloginusers = responseData.entofloginusers; // 运营单元
          this.sysInfo.userInfo.invorgsearchofsyss = responseData.invorgsearchofsyss; // 组织
          this.sysInfo.userInfo.limited = responseData.limited == 2; // 用户是否为限制用户 == 2 时
          this.sysInfo.dbtype = responseData.dbtype ? responseData.dbtype : ''; // 返回数据库类型
          this.sysInfo.SinoccSSoCode = responseData.sinoccssocode ? responseData.sinoccssocode : '';
          this.sysInfo.licenseduehint = responseData.licenseduehint ||  '';
          if (responseData.orgofusers.length > 0) {
            if (responseData.orgofusers[0].orgname) {
              this.sysInfo.userInfo.department = responseData.orgofusers[0].orgname;
            }

          }
          this.sysInfo.userInfo.roleofusers = responseData.roleofusers;
          this.sysInfo.entId = responseData.entid;
          this.sysInfo.entCode = responseData.entcode;
          this.sysInfo.userInfo.EnablePwd = responseData.enablepwd;
          // 修改密码
          let passwordFreq, timeOfLastChangePssword, PasswordInit, isNeedToChangeInitialPasswordParams;
          let mqttUrl = '';
          let mqttUsername = '';
          let mqttPassword = '';
          let portalHomePageUrl = '';

          for (let i = 0; i < responseData.sysconfs.length; i++) {
            switch (responseData.sysconfs[i].confname) {
              case 'WEBOpenFileMethod': // 打开文档的方式
                this.sysInfo.openFileStyle = responseData.sysconfs[i].confvalue;
                break;
              case 'WebIsSpread': // 打开文档的方式
                this.sysInfo.IsSpread = responseData.sysconfs[i].confvalue;
                break;
              case 'MenuViewStyle': // 菜单展示方式
                this.sysInfo.menuStyle = responseData.sysconfs[i].confvalue.toLocaleLowerCase();
                break;
              case 'ModMenuViewStyle': // 门户布局展示方式
                this.sysInfo.ModMenuStyle = responseData.sysconfs[i].confvalue.toLocaleLowerCase();
                break;
              case 'MenuViewColor': // leftmenu的颜色
                if (responseData.sysconfs[i].confvalue != '') {
                  this.sysInfo.color = responseData.sysconfs[i].confvalue;
                } else {
                  this.sysInfo.color = '#343D50';
                }
                break;
              case 'UseFdrMaxSpace': // 录入文档是否限制大小。
                this.sysInfo.UseFdrMaxSpace = responseData.sysconfs[i].confvalue;
                break;
              case 'useFontJudgeOnly': // 启用文字 来鉴别是否安装了 webtool  为 2 是启用
                this.sysInfo.useFontJudgeOnly = responseData.sysconfs[i].confvalue;
                break;
              case 'HideHomePage': // 是否隐藏首页
                this.sysInfo.HideHomePage = responseData.sysconfs[i].confvalue;
                break;
              case 'AutoDispModIds': // 是否有打开时自动加载的模块
                this.sysInfo.AutoDispModIds = responseData.sysconfs[i].confvalue;
                break;
              case 'InitRevLabel': // 初始化版本样式
                this.sysInfo.InitRevLabel = responseData.sysconfs[i].confvalue;
                break;
              case 'PasswordFreq': // 密码修改频率 单位：天 0 不控制是否修改密码,其他为实际天数
                passwordFreq = responseData.sysconfs[i].confvalue;
                break;
              case 'ChangePassword': // 上一次该用户修改的密码的时间戳
                timeOfLastChangePssword = responseData.sysconfs[i].confvalue;
                break;
              case 'PasswordInit': // 初始密码
                PasswordInit = responseData.sysconfs[i].confvalue;
                break;
              case 'PasswordMinLen': // 上一次该用户修改的密码的时间戳
                this.PasswordMinLen = responseData.sysconfs[i].confvalue;
                break;
              case 'PasswordComplexity': // 上一次该用户修改的密码的时间戳
                this.PasswordComplexity = responseData.sysconfs[i].confvalue;
                break;
              case 'portalHomePageUrl ': // 需要跳转到指定页面 不在进入homepage 主界面
                portalHomePageUrl  = responseData.sysconfs[i].confvalue;
                break;
              case 'X6LeftBarBackgroundColor': // 需要跳转到指定页面 不在进入homepage 主界面
               this.sysInfo.X6LeftBarBackgroundColorOfSys  = responseData.sysconfs[i].confvalue;
                break;
              case 'mqttUrl':
               mqttUrl  = responseData.sysconfs[i].confvalue;
                break;
              case 'mqttUsername':
               mqttUsername  = responseData.sysconfs[i].confvalue;
                break;
              case 'mqttPassword':
               mqttPassword  = responseData.sysconfs[i].confvalue;
                break;
              default:
                break;
            }
          }
          window.sessionStorage.setItem('cpcmqtt', JSON.stringify({
            "mqttUrl":mqttUrl,
            "mqttUsername":mqttUsername,
            "mqttPassword":mqttPassword
          }));
          const aa = JSON.stringify({webtoolcrc32: this.webapi.WebtoolCRC32, webtool2crcr32: this.webapi.Webtool2CRC32, openFiletype: this.sysInfo.openFileStyle, webtoolURL: this.sysInfo.webtoolURL});
          window.sessionStorage.setItem('docInfo', aa);
          // 取一下 是不是要限制文件大小的上传；
          const sql  = {
            sql: this.webapi.getEncodeSQL("select b.*  from cpcdict b, cpcdict a where upper(a.dictcode) = upper('UploadFileSizeLimit')  and a.dictid = b.pid")
          };
          this.webapi.post('websqltool', 'select', sql).then(res => {
            let resData = res.json();
            resData = resData.resultdatas;

            if (resData.length > 0) {
              const arr = [];
              // 先筛选 用户有哪些角色 是对应上限制上传大小的角色
              for (let i = 0; i < resData.length; i++) {
                for (let j = 0; j < this.sysInfo.userInfo.roleofusers.length; j++) {
                  let dictname, roleid;
                  dictname = resData[i].dictname.toLowerCase();
                  roleid = this.sysInfo.userInfo.roleofusers[j].roleid.toLowerCase();
                  if (dictname == roleid) {
                    arr.push(resData[i]);
                    break;
                  }
                }
              }
              if (arr.length > 0){
                for (let i = 0; i < arr.length; i++) {
                  if (i === 0) {
                    this.sysInfo.userInfo.UploadFileSizeLimit = arr[i];
                  } else {
                    if (Number(arr[i].dictvalue) >= Number(this.sysInfo.userInfo.UploadFileSizeLimit.dictvalue)) {
                      this.sysInfo.userInfo.UploadFileSizeLimit = arr[i];
                    }
                  }
                }
                this.sysInfo.userInfo.UploadFileSizeLimit.dictvalue =
                  Number(this.sysInfo.userInfo.UploadFileSizeLimit.dictvalue) * 1024 * 1024;
              }


            }

            console.log(resData);
          }, error => {
            const errorData = error.json();
            if (errorData.message) {
              alert(errorData.message);
            }
          });
          // loginguid保存到cookie,调用某些jsp时会取
          // this.cs.put("CPCSESSIONID", responseData.loginguid);
          // document.cookie = "CPCSESSIONID=" + responseData.loginguid;
          // this.sysInfo.initSysInfo();
          // try{
          // 需要跳转到指定页面 不在进入homepage 主界面
          if (portalHomePageUrl.trim() != '') {
            // 有可能需要登录会话有可能不需要
            if (/<LOGINGUID>/i.test(portalHomePageUrl)) {
              portalHomePageUrl = portalHomePageUrl.replace(/<LOGINGUID>/ig, this.webapi.getLoginGUId());
            }
            // 有可能直接配置了完整的是http地址 加个判断
            if (portalHomePageUrl.indexOf('http') != -1) {
              location.href = this.sysInfo.setCellDefValue(portalHomePageUrl);
            } else {
              location.href = window.location.origin + this.sysInfo.setCellDefValue(portalHomePageUrl);
            }

          }
          else if (passwordFreq == '0') {
            this.router.navigateByUrl('index');
            this.sysInfo.appConfig.screen.scale = 21.2;
          }
          // -1 是初始密码时强制要求修改
          else if(Number(passwordFreq) === -1){
            if( String(PasswordInit) === String(this.userInfo.password)){
              this.changePassWordDialogVisible = true;
              this.tip.nativeElement.style.display = 'none';
            } else{
              this.router.navigateByUrl('index');
              this.sysInfo.appConfig.screen.scale = 21.2;
            }
          }
          else {
            // 上次修改密码的时间+要求修改密码的天数,大于当前日期就要改密码了
            let curTime:any = new Date();
            let oldTime:any = new Date(timeOfLastChangePssword);
            // 当前时间减去上一次修改密码的时间大于修改的密码频率
            let day = curTime - oldTime;
            day = day / 1000 / 60 / 60 / 24;
            let needChangePass:boolean = day > Number(passwordFreq);

            // 当前用户 是否允许修改密码
            let loginUserCanChangedPWD:boolean = Number(this.sysInfo.userInfo.EnablePwd) === 2;
            // 用户设置可以修改密码的前提下，（初始密码 或者到期要改密码）都需要去改新的密码
            if (loginUserCanChangedPWD && (PasswordInit == this.userInfo.password || needChangePass)) {
              this.changePassWordDialogVisible = true;
              this.tip.nativeElement.style.display = 'none';
            } else{
              this.router.navigateByUrl('index');
              this.sysInfo.appConfig.screen.scale = 21.2;
            }
          }



          // 系统信息保存到sessionStorage,刷新页面时取用
          const sysinfo = {
            entCode: this.sysInfo.entCode,
            entId: this.sysInfo.entId,
            langs: this.sysInfo.langs,
            loginlogourl: this.sysInfo.loginlogourl,
            logoUrl: this.sysInfo.logoUrl,
            menuStyle: this.sysInfo.menuStyle,
            ModMenuStyle: this.sysInfo.ModMenuStyle,
            openFileStyle: this.sysInfo.openFileStyle,
            title: this.sysInfo.title,
            userInfo: this.sysInfo.userInfo,
            _browserLang: this.sysInfo._browserLang,
            langId: this.sysInfo.langId,
            webapi: this.sysInfo.webapi,
            color: this.sysInfo.color,
            webtoolURL: this.sysInfo.webtoolURL,
            IsSpread: this.sysInfo.IsSpread,
            HideHomePage: this.sysInfo.HideHomePage,
            dbtype: this.sysInfo.dbtype,
            appConfig: this.sysInfo.appConfig,
            X6LeftBarBackgroundColorOfSys: this.sysInfo.X6LeftBarBackgroundColorOfSys,
            SinoccSSoCode: this.sysInfo.SinoccSSoCode,
          };
          const Js = JSON.stringify(sysinfo);
          window.sessionStorage.setItem('sysInfo', Js);
          window.sessionStorage.setItem('cpcenablepwd', responseData.enablepwd);
          // 外部系统的令牌
          window.sessionStorage.setItem('htaccesstoken', responseData.htaccesstoken || '');
          // 存储登录会话 后面 会几秒钟检测 是不是登陆了多个系统不同用户 是的话 比较当前会话是不时最后一次登录的 不是强制退出登录
          // 多个相同用户不退出登录（三诺要求的）
          window.localStorage.setItem('currentGuid', JSON.stringify({userid: this.sysInfo.userInfo.userId, guid: responseData.loginguid}));
          // }
          // catch (oException){
          //   alert( oException.name);
          // }
        }


      }, error => {
        this.tip.nativeElement.style.display = 'none';
        this.isLogin = false;
        this.infoError = true;
        if (error.ok === false && error.status === 502 && error.statusText !== '') {
          alert('登录失败：' + error.statusText);
        } else {
          const errorData = error.json();
          if (errorData.message) {
            this.errorMessage = errorData.message;
            // 简化登录 失败提示一下
            if (this.isSimpleLogin) {
              this.message1.nativeElement.innerText = this.errorMessage;
            }
          }
        }

      }
    );
    // A
    return false;
  }

  changeLoginType() {
    const changeBtn = document.getElementById('changeLoginType');

    if (this.form1.nativeElement.style.display == 'none') {
      this.form1.nativeElement.style.display = 'block';
      this.qrcode_panel.nativeElement.style.display = 'none';
      // changeBtn.innerHTML = this.qrCodeName;
      this.changeLoginAction('密码登录');
    } else{
      this.form1.nativeElement.style.display = 'none';
      this.qrcode_panel.nativeElement.style.display = 'block';
      // changeBtn.innerHTML = '密码登录';
      this.changeLoginAction(this.qrCodeName);
    }

  }
  // 切换登录的方法
  changeLoginAction(str){
    let element, divs;
    divs = document.querySelectorAll('.login_header>div');
    for (let i = 0; i < divs.length; i++) {
      if (divs[i].className.indexOf('cur') != -1) {
        divs[i].className = divs[i].className.replace('cur', '');
        divs[i].style.color = '';
      }
    }
    if (str == this.qrCodeName) {
      element = document.getElementsByClassName('qrcode');
      this.qrcode_panel.nativeElement.style.display = 'block';
      this.form1.nativeElement.style.display = 'none';
      const url = '/qrverifycode.jsp';
      this.http.get(this.qrcodeurl).toPromise().then(res => {
        const json = res.json();
        this.curQCode = json.qrcodecontent;
        const Qrcodeserver = json.qrcodeserver;
        this.http.get(Qrcodeserver).toPromise().then(userData => {
          const data = userData.json();
          this.uiInput.nativeElement.value = data.userid;
          this.doLogin();
        });
      });


    }
    else if (str == '密码登录') {
      element = document.getElementsByClassName('account_password');
      this.qrcode_panel.nativeElement.style.display = 'none';
      this.form1.nativeElement.style.display = 'block';
      this.uiInput.nativeElement.value  = '';
    } else return;
    if (element.length > 0) {
      element[0].className = element[0].className + ' cur';
      element[0].style.color = this.login_text_color ? this.login_text_color : '';
    }
    else return
  }



  getQuery = function(str: string, name: string){ // 取指定名称字符串
  　const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  　const r = str.substr(str.indexOf('?') + 1).match(reg);
  　if (r != null) {
      // return unescape(r[2]);
      return decodeURI(r[2]);
    }
    return null;
  };

  changedLang(item) {
    const span = document.querySelectorAll('.curText');
    span[0].textContent = item.langname;
    this.sysInfo._browserLang = item.localename;
    this.sysInfo.langId = item.langid;
    // let selectOptions:any = document.querySelectorAll('.selectOptions');
    // if(selectOptions[0]) selectOptions[0].style.display = 'none';
  }
  changeLanguage(){
    // console.log(this.selectedLanguage);
    this.sysInfo._browserLang = this.selectedLanguage.localename;
    this.sysInfo.langId = this.selectedLanguage.langid;
    this.translateService.use(this.sysInfo._browserLang);
    if(typeof this.langTitles['title'+this.sysInfo.langId] !== 'undefined'){
      this.sysInfo.title = this.langTitles['title'+this.sysInfo.langId] ;
      document.title = this.sysInfo.title;
    }
  }


  oldPass:any = '';
  newPass:any = '';
  pass:any = '';
  PasswordMinLen='';
  PasswordComplexity= '';
  changePassMsg = '';
  changePassWordDialogVisible: boolean = false;
  changePassWord() {
    this.changePassMsg = '';
    let reg;
    if (this.PasswordComplexity != '') {
      reg = new RegExp(this.PasswordComplexity.split('|')[0]);
    }
    if (this.sysInfo.userInfo.md5sn != String(Md5.hashStr(this.oldPass))) {
      this.changePassMsg = '旧密码不对！';
    } else if (this.newPass.length > 15 ) { // 系统bug 密码不能超过15位
      this.changePassMsg = '新密码不能超过15位，请检查！';
    } else if (this.newPass == this.oldPass) {
      this.changePassMsg = '新旧密码相同！';

    } else if (this.newPass != this.pass) {
      this.changePassMsg = '两次输入的密码不一致！';
    } else if (this.newPass.length === 0) {
      this.changePassMsg = '新密码不能为空！';

    } else if (this.newPass.length > 0 && this.newPass.length < parseInt (this.PasswordMinLen)) {
      this.changePassMsg = '密码位数不能小于' + this.PasswordMinLen + '位!';
    } else if (reg && reg.test(this.newPass) == false) { // 有密码强度要求
      this.changePassMsg = this.PasswordComplexity.split('|')[1] || '不符合密码强度规则';
    }
    if (this.changePassMsg.length > 0) {
      return;
    } else { // 修改成功
      const data = {
        userpass: this.webapi.base64encode(Md5.hashStr(this.pass)),
        md5sn: Md5.hashStr(this.pass),
        enablepwd: Number(this.sysInfo.userInfo.EnablePwd) === 2 ? 0 : Number(this.sysInfo.userInfo.EnablePwd),
      };
      console.log(this.sysInfo.userInfo.EnablePwd);
      const that = this;
      this.webapi.post('cpcuser', 'changepassword', data).then(response => {
        if (response.statusText == 'OK') {
          this.sysInfo.userInfo.md5sn = String(Md5.hashStr(this.pass));
          this.sysInfo.userInfo.password = this.userInfo.password = this.pass;
          this.changePassMsg = '修改密码成功，即将跳转！';
          this.changePassWordDialogVisible = false;
          // 存一下密码 到时候 用户在流程界面调用webtool要用到
          window.sessionStorage.setItem('pw', this.webapi.base64encode(this.webapi.base64encode(this.webapi.utf16to8((this.pass)))));
          setTimeout(function(){
            that.router.navigateByUrl('index');
            that.sysInfo.appConfig.screen.scale = 21.2;
          }, 500);

        }
      });
    }

  }
  // appConfig={
  //   screen: {
  //     width: 1920,
  //     height: 1080,
  //     scale: 21.6
  //   }
  // };
  //
  @HostListener('window:resize')
  init() {
    // console.log(window.innerHeight + "," + window.innerWidth);
    if (this.loginContent.nativeElement) {
      document.documentElement.style.fontSize = ~~(this.loginContent.nativeElement.clientWidth / this.sysInfo.appConfig.screen.scale) + 'px';
    }

  };
  // myCookie (name, value, options) {
  //   if (typeof value != 'undefined') { // name and value given, set cookie
  //     options = options || {};
  //     if (value === null) {
  //       value = '';
  //       options.expires = -1;
  //     }
  //     let expires = '';
  //     if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
  //       let date;
  //       if (typeof options.expires == 'number') {
  //         date = new Date();
  //         date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
  //       } else {
  //         date = options.expires;
  //       }
  //       expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
  //     }
  //
  //     let path = options.path ? '; path=' + (options.path) : '';
  //     let domain = options.domain ? '; domain=' + (options.domain) : '';
  //     let secure = options.secure ? '; secure' : '';
  //     document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
  //   } else { // only name given, get cookie
  //     let cookieValue = null;
  //     if (document.cookie && document.cookie != '') {
  //       let cookies = document.cookie.split(';');
  //       for (let i = 0; i < cookies.length; i++) {
  //         let cookie = cookies[i].trim();
  //         // Does this cookie string begin with the name we want?
  //         if (cookie.substring(0, name.length + 1) == (name + '=')) {
  //           cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
  //           break;
  //         }
  //       }
  //     }
  //     return cookieValue;
  //   }
  // };

}



// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/login/login.component.ts